import { render, staticRenderFns } from "./MemoryStack.vue?vue&type=template&id=0e32e578&scoped=true&"
import script from "./MemoryStack.vue?vue&type=script&lang=ts&"
export * from "./MemoryStack.vue?vue&type=script&lang=ts&"
import style0 from "./MemoryStack.vue?vue&type=style&index=0&id=0e32e578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32e578",
  null
  
)

export default component.exports